module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-mv.0331d4b8.png";